import { gtag } from "utils/gtag";

// Single lead-conversion signal shared by BOTH the contact page and the chat
// assistant, so every submission is reported the same way and can still be
// segmented.
//
// Fired only on a *successful* submission (the contact form navigates to
// /thank-you and fires this on mount; the chat calls it inline after a
// successful send), so every fire is a real, completed lead — not a click or a
// validation failure.
//
// Emits three things on the one shared Google tag (G-…) installed in
// index.html:
//   1. GA4 page_view to /thank-you — funnel visibility for chat leads that
//      never actually navigate there.
//   2. GA4 `generate_lead` event tagged source + lead_type (segmentation).
//   3. Google Ads `ads_conversion_Contact_1` — the "Contact" conversion action,
//      measured on the /thank-you confirmation ("Page load" method). The Ads
//      conversion is linked to the same Google tag, so no separate AW- id.
//
// @param {Object} opts
// @param {"contact_page"|"chat"} opts.source     Where the lead came from.
// @param {"inquiry"|"partnership"} opts.leadType Kind of lead.
const ADS_CONVERSION_EVENT = "ads_conversion_Contact_1";

export const trackLead = ({ source, leadType }) => {
  gtag("event", "page_view", {
    page_path: "/thank-you",
    page_title: "Thank You"
  });
  gtag("event", "generate_lead", { source, lead_type: leadType });
  gtag("event", ADS_CONVERSION_EVENT, {});
};
